import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';
import markerIcon from './marker2.png';
import { apiHost } from '../../utils/apiHost';

// Komponen pembantu untuk me-resize peta
function ResizeMap() {
  const map = useMap();
  useEffect(() => {
    // Delay untuk memastikan peta memiliki ukuran yang benar
    let mounted = true;
    const handle = setTimeout(() => {
      if (!mounted) return;
      try {
        if (map && typeof map.invalidateSize === 'function') {
          map.invalidateSize();
        }
      } catch (err) {
        console.warn('Error invalidating leaflet map size:', err);
      }
    }, 300);

    // Also try when map is ready
    try {
      if (map && typeof map.whenReady === 'function') {
        map.whenReady(() => {
          try { if (mounted && typeof map.invalidateSize === 'function') map.invalidateSize(); } catch(e){}
        });
      }
    } catch (e) {}

    return () => { mounted = false; clearTimeout(handle); };
  }, [map]);
  return null;
}

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

// cabang (opsional) = { koordinat, radius } milik karyawan yang absen. Tanpa props ini (layar absen
// karyawan sendiri) data cabang diambil dari /me. tinggi = tinggi peta (default mengikuti wadah).
const Lokasi = ({ latitude, longitude, cabang, tinggi = '100%' }) => {
  const [branchData, setBranchData] = useState(cabang || null);

  useEffect(() => {
    if (cabang) {
      setBranchData(cabang);
      return;
    }
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(`${getApiBaseUrl()}/me`, { withCredentials: true });
        const { cabang } = response.data;
        if (cabang) {
          setBranchData(cabang);
        }
      } catch (error) {
        console.error('Error fetching user or branch data:', error);
      }
    };

    fetchProfileData();
  }, [cabang]);

  if (latitude === null || longitude === null || latitude === undefined || longitude === undefined) {
    return null;
  }

  // Koordinat dan radius cabang (bila tersedia) untuk lingkaran radius kantor
  const [cabangLat, cabangLon] = String(branchData?.koordinat || '').split(',').map(Number);
  const radius = Number(branchData?.radius);
  const adaRadius = Number.isFinite(cabangLat) && Number.isFinite(cabangLon) && radius > 0;

  const customMarkerIcon = L.icon({
    iconUrl: markerIcon,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [0, -41],
  });

  return (
    <MapContainer
      center={[latitude, longitude]}
      zoom={17}
      style={{ height: tinggi, width: '100%' }}
    >
      <ResizeMap />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* Marker untuk lokasi pengguna */}
      <Marker position={[latitude, longitude]} icon={customMarkerIcon}>
        <Popup>Lokasi absen</Popup>
      </Marker>

      {/* Circle untuk radius kantor cabang */}
      {adaRadius && <Circle
        center={[cabangLat, cabangLon]}
        radius={radius}
        color='blue'
        fillColor='#1E90FF'
        fillOpacity={0.5}
      >
        <Popup>Radius Kantor Cabang</Popup>
      </Circle>}
    </MapContainer>
  );
};

export default Lokasi;